<template>
  <section class="crm-toolbar">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "CrmToolbar",
};
</script>

<style scoped>
.crm-toolbar {
  background: #ffffff;
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(23, 31, 56, 0.04);
  margin-bottom: 18px;
  padding: 16px;
}
</style>
